import audio1 from './Audio/audio1.mp3'
import audio2 from './Audio/audio2.mp3'
import audio3 from './Audio/audio3.mp3'
import audio4 from './Audio/audio4.mp3'
const data = [
    {
        title: 'Good morning! This is your daily briefing on the latest tech news and trends.',
        audio: audio1,
    },
    {
        title: "Welcome to our podcast! Today we're exploring the future of artificial intelligence and how transforming everyday life. Stay tuned for some incredible insights from industry experts.",
        audio: audio2,
    },
    {
        title: "Breaking news update: Scientists have made a groundbreaking discovery in renewable energy technology. This advancement could revolutionize how we power our homes and businesses in the coming decade.",
        audio: audio3,
    },
    {
        title: "Hey there! Thanks for joining our tutorial series. In this episode, we'll walk you through the essential steps to master video editing. Let's get started and unleash your creativity!",
        audio: audio4,
    },

]
export default function ContentVoice() {
    return (
        <div className="text-white text-center">
            <div>
                {
                    data.map((item, index) => <div className='mb-5' key={index}>
                        <p className='fw-bold'>{item.title}</p>
                        <audio controls>
                            <source src={item.audio} type="audio/mpeg" />
                        </audio>
                    </div>)
                }
            </div>
        </div>
    );
}